
export const sidebarUser = {
  'backoffice.sidebarUser.sections.dashboard.title': 'Kontrol Paneli',
  'backoffice.sidebarUser.sections.dashboard.items.summary': 'Özet',
  'backoffice.sidebarUser.sections.myCommunity.title': 'Topluluğum',
  'backoffice.sidebarUser.sections.myCommunity.items.genealogyTree': 'Soy Ağacı',
  'backoffice.sidebarUser.sections.myCommunity.items.communityMembers': 'Topluluk Üyeleri',
  'backoffice.sidebarUser.sections.investmentAccounts.title': 'Yatırım Hesapları',
  'backoffice.sidebarUser.sections.investmentAccounts.items.myAccounts': 'Hesaplarım',
  'backoffice.sidebarUser.sections.investmentAccounts.items.addAccount': 'Hesap Ekle',
  'backoffice.sidebarUser.sections.myProfits.title': 'Kârlarım',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitSummary': 'Hesap Kâr Özeti',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitHistory': 'Hesap Kâr Geçmişi',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsSummary': 'Komisyon Özeti',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsHistory': 'Komisyon Geçmişi',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsPaymentHistory': 'Komisyon Ödeme Geçmişi',
  'backoffice.sidebarUser.sections.myProfits.items.myPaymentMethods': 'Ödeme Yöntemlerim',
  'backoffice.sidebarUser.sections.startInvesting.title': 'Yatırıma Başla',
  'backoffice.sidebarUser.sections.startInvesting.items.createRadexAccount': 'Radex Markets Hesabı Oluştur',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammInstitutional': 'PAMM Institutional Trading\'e Katılın',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammSpartanAi': 'PAMM Spartan AI\'ye Katılın',
  'backoffice.sidebarUser.sections.startInvesting.items.accessPammAccount': 'PAMM Hesabınıza Erişin',
  'backoffice.sidebarUser.sections.tutorials.title': 'Eğitimler',
  'backoffice.sidebarUser.sections.myProfile.title': 'Profilim',
  'backoffice.sidebarUser.sections.myProfile.items.theClubUserProfile': 'The Club Kullanıcı Profili',
  'backoffice.sidebarUser.sections.myProfile.items.personalInformation': 'Kişisel Bilgilerim',
  'backoffice.sidebarUser.sections.myProfile.items.paymentMethods': 'Ödeme Yöntemlerim',
  'backoffice.sidebarUser.sections.myProfile.items.referralLink': 'Referans Bağlantım',
  'backoffice.sidebarUser.sections.support.title': 'Destek',
  'backoffice.sidebarUser.sections.support.items.helpCenter': 'Yardım Merkezi',
  'backoffice.sidebarUser.signOut': 'Çıkış Yap'
};
